module.exports = __webpack_public_path__ + "img/shop_A_4.d54b1dba.png";